import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { getAllBranches } from "../../../redux/branchSlice/branchSlice";
import { getSpecificCompany } from "../../../redux/companySlice/companySlice";

export default function BranchSelect({ setSelectedBranch, selectedCompany, selectedBranch }) {
  const dispatch = useDispatch();
  const { specificCompany } = useSelector((state) => state.company);
  const { branch } = useSelector((state) => state.branch);
  const [allBranchesData, setAllBranchesData] = useState([]);
  useEffect(() => {
    if (selectedCompany?.value) {
      dispatch(getSpecificCompany(selectedCompany.value));
    }
  }, [selectedCompany, branch]);
  useEffect(() => {
    if (specificCompany) {
      setAllBranchesData(specificCompany.branches);
    }
  }, [specificCompany]);
  const branchOptions =
    allBranchesData &&
    allBranchesData.length > 0 &&
    allBranchesData?.map((branch) => ({
      value: branch.id,
      label: branch.name,
    }));

  const handleBranchChange = (selectedOption) => {
    console.log("Selected Branch:", selectedOption);
    setSelectedBranch(selectedOption);
  };

  return (
    <div>
      <label htmlFor="branchSelect">اختر الفرع</label>
      <Select
        options={branchOptions ? branchOptions : []}
        onChange={handleBranchChange}
        value={selectedBranch}
        placeholder="اختر الفرع"
        isSearchable
        classNames={{
          control: (state) => (state.isFocused ? "selectSearchFocus" : "selectSearch"),
        }}
      />
    </div>
  );
}
